import Vue from "vue";
import Vuetify from "vuetify/lib";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { far } from "@fortawesome/free-regular-svg-icons";
import WpFontAwesome from "@/components/atoms/WpFontAwesome.vue";
import ChevronDown from "@/assets/icons/chevron-down.svg";

Vue.component("font-awesome-icon", FontAwesomeIcon); // Register component globally
library.add(far);

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "faSvg",
    values: {
      next: {
        component: WpFontAwesome,
        props: {
          icon: "fa-circle-right",
          iconOnly: false,
          color: "secondary",
        },
      },
      prev: {
        component: WpFontAwesome,
        props: {
          icon: "fa-circle-left",
          iconOnly: false,
          color: "secondary",
        },
      },
      error: {
        component: WpFontAwesome,
        props: {
          icon: "fa-circle-xmark",
          iconOnly: false,
          color: "secondary",
        },
      },
      customIconSvg: ChevronDown,
      customIconSvgPath: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
    },
  },
  theme: {
    options: {
      variations: false,
      customProperties: true,
    },
    dark: false,
    themes: {
      light: {
        primary: "#0061FF",
        secondary: "#585F66",
        accent: "#f2f8fd",
        error: "#FF5252",
        warning: "#f89820",
        success: "#4CAF50",
        info: "#2196F3",
      },
    },
  },
});
